import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme:{
        themes:{
            light:{
                primary: '#3d6eb1',
                secondary: '#eb1e77',
                thertiarty:'#51bec2',
                compeatsecondary: '#c03b7d',
                compeatthird: '#65afbf',
                error: '#c10100',
                success: '#6aa84f',
                frontendblue: '#65b8e8'
                //  primary:'#eebf00'
            }
        }
    }
});
